import React from 'react';
import { ToastContext, useToastState } from '../hooks/useToast';

interface ToastProviderProps {
  children: React.ReactNode;
}

/**
 * Top-right toast stack (FR-004/005/006/008/012/017 — "toaster appears in
 * the right top corner"). No toast system existed in this app before
 * sc-43661; this is the first one, so there is nothing else to match beyond
 * the reserved `--au-z-toast` token already sitting unused in tokens.css.
 */
const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const toastValue = useToastState();

  return (
    <ToastContext.Provider value={toastValue}>
      {children}
      <div aria-live="polite" className="au-toast-stack" data-testid="toast-container">
        {toastValue.toasts.map((toast) => (
          <div
            key={toast.id}
            role="status"
            className={`au-toast au-toast--${toast.variant}`}
            data-testid="toast"
          >
            <span>{toast.message}</span>
            <button
              type="button"
              className="au-toast-close"
              aria-label="Dismiss"
              onClick={() => toastValue.dismissToast(toast.id)}
            >
              <svg
                className="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export default ToastProvider;
